export const LetterOfDirectionResponseConstants = {
    Approve: "Approve",
    Deny: "Deny"
  };